import { Case } from "../interfaces/Patient";
import { BCHomePermissionID, UserData } from "../interfaces/UserInfo";
import { getUser } from "./Auth";

export const isUserSuperUser = () => {
    const user: UserData = getUser();
    return user.user_roles?.some(r => r.role?.code === 'super_user') ?? false;
};

export const userHasRolePermission = (permissionID: BCHomePermissionID) => {
    const user: UserData = getUser();
    return user.user_roles?.some(r => r.role?.permissions?.some(p => p.id === permissionID)) ?? false;
}

export const canAccessBCHome = () => userHasRolePermission('bchome_access');

export const canAccessUbikare = () => userHasRolePermission('ubikare_access');

export const canEditCaseView = (caso: Case | null) => {
    if (caso === null) return false;
    const openedCase = caso.end_date === null;
    return openedCase || isUserSuperUser();
}

export const canUserCloseCase = (caso: Case | null) => {
    if (caso === null) return false;
    const openedCase = caso.end_date === null;
    return openedCase && userHasRolePermission('case_close');
}